/*
 * Application Insights JavaScript SDK - React Plugin, 19.3.8
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
import { createContext, useContext } from "react";
var AppInsightsContext = createContext(undefined);
var useAppInsightsContext = function () { return useContext(AppInsightsContext); };
export { AppInsightsContext, useAppInsightsContext };
